import { handleUnauthorized } from "$lib/utils/errorManagement/errorInterceptors";
import axios, { type AxiosInstance } from "axios";
import * as R from "ramda";

const instance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
  },
  withCredentials: true,
});

instance.interceptors.response.use(R.identity, handleUnauthorized);

export default Object.freeze({
  get instance(): AxiosInstance {
    return instance;
  },
});
